import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import financialTransactionsApi from '@/features/dashboard/financialTransactions/api/financialTransactionsApi.ts';
import { invalidateFinanceRelatedQueries } from '@/utils/invalidateFinanceQueries.ts';

interface DeleteAllocationParams {
  transactionId: string;
  allocationId: string;
}

/**
 * Odpina pojedynczą zapłatę od wydatku. Sama transakcja zostaje — jej kwota
 * wraca do puli niezaalokowanych i widać ją w filtrze
 * `withUnallocatedRemainder` na globalnej liście transakcji.
 */
const useDeleteTransactionAllocation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ transactionId, allocationId }: DeleteAllocationParams) =>
      financialTransactionsApi.deleteAllocation(transactionId, allocationId),
    onSuccess: () => {
      invalidateFinanceRelatedQueries(queryClient);
      toast.success('Zapłata została odpięta', {
        description: 'Transakcja wróciła do puli do rozdysponowania.',
      });
    },
    onError: (error: Error) => {
      toast.error('Nie udało się odpiąć zapłaty', {
        description: error.message,
      });
    },
  });
};

export default useDeleteTransactionAllocation;
